import * as THREE from "three";
import {RouterModel} from "../../Model/RouterModel";
import {Card} from "../../Shapes/Card";
import {Group} from "three";
import {Line} from "../../Shapes/Line";

export function ManagerRouter(
    scene: THREE.Scene,
    x: number,
    z: number,
    type: string,
    name: string,
	id: string,
): void {

    const y: number = 0.02;
    z = z+1

    // Ligne au dessus
    Line(scene, x, z + 1, x, z + 4)

    // Création du routeur
    const routerModel = new RouterModel(type, id);
    const router = routerModel.getGroup();

    // Création card
    let card: Group;
    if (type === "router") {
        const cardModel = new Card(true, name, "Router");
        card = cardModel.getGroup()
    } else {
        const cardModel = new Card(true, name, "Firewall");
        card = cardModel.getGroup()
    }

    // Position
    router.position.set(x, y, z + 4);
    card.position.set(x, 3, z + 5.5);
    card.rotation.x = -Math.PI / 2;

    // Add Scene
    scene.add(router, card);
}
